export { default as ProductsIndexPageCategoriesNavItem } from './ProductsIndexPageCategoriesNavItem';
